<template>
  <div>
    <v-card class="PlanejamentoContratoFormCampos__Card--treslinhas">
      <v-form ref="formProponente"
        lazy-validation
        auto-complete="off">
        <v-container fluid grid-list-md>
          <v-row>
            <v-col cols="12" >
              <v-autocomplete
                id="planejamento-autocomplete-divisao"
                class="custom-autocomplete"
                v-model="contrato.divisao"
                return-object
                :rules="rules.requiredFunction('divisao', 'nome')"
                :items="divisoesFiltradas"
                :label="`${$tc('label.divisao', 1)} *`"
                :no-data-text="$tc('message.nenhum_registro', 1)"
                item-text="nome"
                item-value="id"
                required
                :disabled="somenteLeitura || desabilitaDivisao"
                :clearable="true"
                @input="divisaoAlterada"
                @click:append="() => triggerSelecao('planejamento-autocomplete-divisao')"
                @click.native="(i) => buscaAutocomplete(i, buscarDivisoes)">
              </v-autocomplete>
            </v-col>
            <v-col cols="12" v-if="!configuracao.isTipoContratoCartaParceria
              && !configuracao.isTipoContratoSamsung && !configuracao.isTipoContratoNivelFamilia && !configuracao.isTipoContratoEpoca">
              <v-autocomplete
                id="planejamento-autocomplete-unidadenegocio"
                class="custom-autocomplete"
                v-model="contrato.unidadeNegocio"
                return-object
                :rules="rules.requiredFunction('unidadeNegocio', 'nomExtensao')"
                :items="unidadesNegocioDivisao"
                :label="`${$tc('label.unidade_negocio', 1)} *`"
                :no-data-text="$tc('message.nenhum_registro', 1)"
                item-text="nomExtensao"
                item-value="id"
                required
                :disabled="somenteLeitura || desabilitaUnidadeNegocio"
                :clearable="true"
                @input="unidadeNegocioAlterada"
                @click:append="() => triggerSelecao('planejamento-autocomplete-unidadenegocio')"
                @click.native="(i) => buscaAutocomplete(i, buscarUnidadesNegocioDivisao)">
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row v-if="!vigenciaPeriodo">
            <v-col cols="12" md="6">
              <metadados-campo-dinamico-data
                :metadados="definicaoDtaInicio"
                v-model="contrato.dtaVigenciaInicio"
                :somente-leitura="somenteLeitura || vigenciaHerdada"
                :objeto-container="contrato"
                @MetadadosCampoDinamico_valorAlterado="dataInicioAlterada"/>
            </v-col>
            <v-col cols="12" md="6" v-if="contrato.dtaVigenciaFimOriginal">
              <metadados-campo-dinamico-data
                :metadados="definicaoDtaFim"
                v-model="contrato.dtaVigenciaFimOriginal"
                :somente-leitura="somenteLeitura || vigenciaHerdada || vigenciaPredeterminada"
                :objeto-container="contrato"
                @MetadadosCampoDinamico_valorAlterado="dataFimAlterada"/>
            </v-col>
            <v-col cols="12" md="6" v-else>
              <metadados-campo-dinamico-data
                :metadados="definicaoDtaFim"
                v-model="contrato.dtaVigenciaFim"
                :somente-leitura="somenteLeitura || vigenciaHerdada || vigenciaPredeterminada"
                :objeto-container="contrato"
                @MetadadosCampoDinamico_valorAlterado="dataFimAlterada"/>
            </v-col>
            <v-col cols="12" md="6" v-if="contrato.dtaVigenciaFimOriginal">
              <metadados-campo-dinamico-data
                :metadados="definicaoDtaProrrogacao"
                v-model="contrato.dtaVigenciaFim"
                :somente-leitura="true"
                :objeto-container="contrato"
                @MetadadosCampoDinamico_valorAlterado="dataFimAlterada"/>
            </v-col>
            <v-col cols="12" sm="6">
              <v-row class="ma-0 pa-0 pr-2">
                <v-switch
                  v-if="exibirFlagSemVerba"
                  :disabled="somenteLeitura"
                  id="config_acao_desc_automatica"
                  :style="{ fontWeight: 'bold' }"
                  v-model="contrato.indSemVerba"
                  @change="ativaFlagSemVerba"
                  :label="$tc('label.sem_verba').toUpperCase()"/>
              </v-row>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12">
              <v-autocomplete
                id="planejamento-autocomplete-periodo"
                class="custom-autocomplete"
                v-model="contrato.periodoPlanejamento"
                return-object
                :rules="rules.requiredFunction('periodoPlanejamento', 'nome')"
                :items="periodosPlanejamento"
                :label="`${$tc('label.periodo', 1)} *`"
                :no-data-text="$tc('message.nenhum_registro', 1)"
                item-text="nome"
                item-value="id"
                required
                :disabled="somenteLeitura || desabilitaPeriodo"
                :clearable="true"
                @click:append="() => triggerSelecao('planejamento-autocomplete-periodo')"
                @click.native="(i) => buscaAutocomplete(i, buscarPeriodosPlanejamento)">
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card>

    <confirm
      ref="modalIndSemVerba"
      :message="mensagemConfirmacaoIndSemVerba"
      :persistent="true"
      :maxWidth="'450'"
      @agree="confirmaAtivacaoFlagSemVerba(true)"
      @disagree="confirmaAtivacaoFlagSemVerba(false)"/>
    <confirm
      ref="modalIndSemVerbaFalse"
      :message="mensagemConfirmacaoIndSemVerba"
      :persistent="true"
      :maxWidth="'450'"
      @agree="confirmaAtivacaoFlagSemVerba(false)"
      @disagree="confirmaAtivacaoFlagSemVerba(true)"/>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import { buscaAutocomplete, triggerSelecao } from '@/common/functions/autocomplete-utils';
import Confirm from '@/shared-components/dialog/Confirm';
import MetadadosCampoDinamicoData from '@/shared-components/metadados/campos-dinamicos/MetadadosCampoDinamicoData';

export default {
  props: {
    novoContrato: Boolean,
    somenteLeitura: Boolean,
    configuracao: {
      type: Object,
      required: true,
    },
    contrato: Object,
    tipoContrato: Object,
  },
  data() {
    return {
      planejamentoAcaoResource: this.$api.planejamentoAcaoCadastro(this.$resource),
      definicaoDtaInicio: {
        labelCampo: 'inicio_vigencia',
        nomCampoId: 'dtaInicio',
        tipoCampo: 'DATA',
        vlrObrigatorio: true,
      },
      definicaoDtaFim: {
        labelCampo: 'fim_vigencia',
        nomCampoId: 'dtaFim',
        tipoCampo: 'DATA',
        vlrObrigatorio: true,
      },
      definicaoDtaProrrogacao: {
        labelCampo: 'data_prorrogacao',
        nomCampoId: 'dtaFimOriginal',
        tipoCampo: 'DATA',
        vlrObrigatorio: false,
      },

      divisoesFiltradas: [],
      divisoesUsuario: [],
      unidadesNegocioDivisao: [],
      periodosPlanejamento: [],

      mensagemConfirmacaoIndSemVerba: null,
      indVerificaMudancaFlagFalse: false,

      rules: {
        required: (value) => !!value || this.$t('message.campo_obrigatorio'),
        requiredFunctionOpcional: (objLabel, valueLabel, obrigatorio) => [
          () => {
            if (!obrigatorio) {
              return true;
            }

            const objeto = this.contrato[objLabel] || {};
            const val = objeto[valueLabel];
            const msg = this.$t('message.campo_obrigatorio');
            return !!(val) || msg;
          },
        ],
        requiredFunction: (objLabel, valueLabel) => [
          () => {
            const objeto = this.contrato[objLabel] || {};
            const val = objeto[valueLabel];
            const msg = this.$t('message.campo_obrigatorio');
            return !!(val) || msg;
          },
        ],
      },
    };
  },
  components: {
    MetadadosCampoDinamicoData,
    Confirm,
  },
  computed: {
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    vigenciaPeriodo() {
      const { tipoVigencia } = this.configuracao;
      return ['VIGENCIA_PERIODO'].includes(tipoVigencia);
    },
    vigenciaHerdada() {
      const { tipoVigencia } = this.configuracao;
      const herdarPeriodo = ['HERDAR_PERIODO_ACAO'].includes(tipoVigencia);

      if (herdarPeriodo && this.novoContrato) {
        this.contrato.dtaVigenciaInicio = this.moment().format('YYYY-MM-DD');
        this.contrato.dtaVigenciaFim = this.moment().format('YYYY-MM-DD');
      }
      return herdarPeriodo;
    },
    desabilitaDivisao() {
      return !this.novoContrato || this.divisoesUsuario.length <= 1;
    },
    desabilitaUnidadeNegocio() {
      const { divisao } = this.contrato;
      if (!divisao || !divisao.id || this.unidadesNegocioDivisao.length <= 1) {
        return true;
      }
      return false;
    },
    desabilitaPeriodo() {
      return this.periodosPlanejamento.length === 1;
    },
    vigenciaPredeterminada() {
      const { tipoVigencia } = this.configuracao;
      return ['VIGENCIA_PREDETERMINADA'].includes(tipoVigencia);
    },
    exibirFlagSemVerba() {
      return ((!this.somenteLeitura && this.cadastrarContratoSemVerba) || (this.somenteLeitura && this.contrato.indSemVerba))
        && !this.isTipoContratoSamsung && !this.isTipoContratoNivelFamilia && !this.isTipoContratoEpoca;
    },
    cadastrarContratoSemVerba() {
      return this.getAllRoles
        .filter((el) => el.indexOf('CADASTRAR_CONTRATO_SEM_VERBA_CONF') !== -1).length > 0;
    },
  },
  methods: {
    buscaAutocomplete,
    triggerSelecao,
    buscarDivisoes(autocomplete) {
      this.divisoesFiltradas = this.divisoesUsuario
        .filter((divisao) => divisao.nome.indexOf(autocomplete) >= 0);
    },
    extensaoAlterada() {
      this.$emit('PlanejamentoContratoForm__CampoProdutoAlterado');
      if (this.$refs.formFocoContrato) {
        this.$refs.formFocoContrato.limpaFocoAcao();
      }
    },
    buscarDivisoesUsuario() {
      this.planejamentoAcaoResource.buscarDivisoes()
        .then((res) => {
          this.divisoesUsuario = res.data;
          this.divisoesFiltradas = res.data;
          if (this.divisoesUsuario.length === 1) {
            const unicaDivisao = this.divisoesUsuario[0];
            this.contrato.divisao = { ...unicaDivisao };
            // this.buscarUnidadesNegocioDivisao();
          }
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    buscarUnidadesNegocioDivisao(autocomplete) {
      const idDivisao = this.contrato.divisao.id;
      const parametros = { idDivisao, autocomplete };
      return this.planejamentoAcaoResource
        .buscarUnidadesNegocioDivisao(parametros)
        .then((res) => {
          this.unidadesNegocioDivisao = res.data;
          if (this.unidadesNegocioDivisao.length === 1) {
            const unicaUnidade = this.unidadesNegocioDivisao[0];
            this.contrato.unidadeNegocio = { ...unicaUnidade };
          }
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    buscarPeriodosPlanejamento(autocomplete) {
      return this.planejamentoAcaoResource
        .buscarPeriodosVigentePlanejamento({ autocomplete })
        .then((res) => {
          this.periodosPlanejamento = res.data;
          if (this.periodosPlanejamento.length === 1) {
            const unicoPeriodo = this.periodosPlanejamento[0];
            this.contrato.periodoPlanejamento = { ...unicoPeriodo };
          }
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    divisaoAlterada() {
      if (this.contrato.unidadeNegocio) {
        this.contrato.unidadeNegocio = {};
      }
      if (this.contrato.divisao) {
        this.contrato.divisao.codNome = this.contrato.divisao.id;
        // this.buscarUnidadesNegocioDivisao();
      }
    },
    unidadeNegocioAlterada() {
      this.$emit('PlanejamentoContratoForm__CampoProdutoAlterado');
    },
    valida() {
      if (!this.$refs.formProponente.validate()) {
        return false;
      }
      return this.validarDatas();
    },
    validarDatas() {
      const dataInicial = moment(this.contrato.dtaVigenciaInicio);
      const dataFinal = moment(this.contrato.dtaVigenciaFim);

      if (dataFinal.isBefore(dataInicial)) {
        this.$toast(this.$t('message.data_inicial_maior_final'));
        return false;
      }

      return true;
    },
    getContrato() {
      const {
        divisao,
        unidadeNegocio,
        periodoPlanejamento,
        dtaVigenciaInicio,
        dtaVigenciaFim,
      } = this.contrato;

      return {
        idDivisao: divisao.id,
        idUnidadeNegocio: unidadeNegocio ? unidadeNegocio.id : null,
        idPeriodo: periodoPlanejamento ? periodoPlanejamento.id : null,
        dtaVigenciaInicio,
        dtaVigenciaFim,
      };
    },
    setContratoEdicao(contrato) {
      const { unidadeNegocio, periodoPlanejamento, divisao } = contrato;
      this.divisoesFiltradas = [divisao];
      if (unidadeNegocio) {
        this.unidadesNegocioDivisao = [unidadeNegocio];
      }
      if (periodoPlanejamento) {
        this.periodosPlanejamento = [periodoPlanejamento];
      }
    },
    dataInicioAlterada(dataInicio) {
      if (this.vigenciaPredeterminada && dataInicio) {
        const data = new Date(moment(dataInicio));
        this.contrato.dtaVigenciaFim = moment(new Date(
          data.getFullYear() + this.configuracao.anosDuracaoVigencia,
          data.getMonth(),
          data.getDate(),
        ), 'DD-MM-YYYY').format('YYYY-MM-DD');
      }
      this.$emit('PlanejamentoContratoForm__CampoDataInicioAlterado', dataInicio);
    },
    dataFimAlterada(dataFim) {
      this.$emit('PlanejamentoContratoForm__CampoDataFimAlterado', dataFim);
    },
    ativaFlagSemVerba(valor) {
      this.indVerificaMudancaFlagFalse = !valor;
      if (valor) {
        this.mensagemConfirmacaoIndSemVerba = this.$t('message.ativacaoFlagSemVerba');
        setTimeout(() => this.$refs.modalIndSemVerba.open());
      } else {
        this.mensagemConfirmacaoIndSemVerba = this.$t('message.ativacaoFlagSemVerbaFalse');
        setTimeout(() => this.$refs.modalIndSemVerbaFalse.open());
      }
    },
    confirmaAtivacaoFlagSemVerba(valor) {
      if (valor) {
        this.contrato.indSemVerba = true;
      } else {
        this.contrato.indSemVerba = false;
      }
      this.$emit('PlanejamentoContratoFormAcoesControle__indSemVerba', this.contrato.indSemVerba);
    },
  },
  mounted() {
    if (this.novoContrato) {
      if (!this.somenteLeitura) {
        this.buscarDivisoesUsuario();
      }
      if (this.vigenciaHerdada) {
        this.contrato.dtaVigenciaInicio = this.moment().format('YYYY-MM-DD');
        this.contrato.dtaVigenciaFim = this.moment().format('YYYY-MM-DD');
      } else if (this.vigenciaPeriodo) {
        this.buscarPeriodosPlanejamento();
      }
    }
  },
};
</script>
